module.exports = __webpack_public_path__ + "static/media/app.71c8de11.png";